import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import { Outlet, useNavigate } from 'react-router-dom';

const AdminLayout = () => {

  let navigate = useNavigate();
  useEffect(() => {
    const validateLogin = async () => {
      // Validate Login from localStorage
      let token = localStorage.getItem("token");
      let user = localStorage.getItem("user");
      
      if (token && user) {
        try {
          const userData = JSON.parse(user);
          
          if (userData.userType === "admin") {
            localStorage.setItem("username", userData.firstName || userData.email.split("@")[0]);
          } else {
            navigate("/login");
          }
        } catch (error) {
          navigate("/login");
        }
      } else {
        navigate("/login");
      }
    }

    validateLogin()
  }, [navigate])
  return (
    <>
      <Navbar />
      <div className="main-content">
        <Sidebar role="admin" />
        <div className="content-area">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default AdminLayout;
